export const normalizeTree = (childrenKey) => (tree) => {
  const reducer = (res, next) => {
    res.push(next);
    res.push(...next[childrenKey].reduce(reducer, []));
    return res;
  };
  return tree.reduce(reducer, []);
};
